import { makeAsyncAction } from '../../../ui-lottery';
import * as types from '../constants/actions';
import * as api from '../api';
import { decodeAsset, buildCall } from '../utils/asset';
import { keysToSnakeCase } from '../../../ui-lottery/src/utils/object_utils';
import { makeAsyncResetAction } from "../../../ui-lottery/src/utils/async_utils";

export const fetchAssets = makeAsyncAction(
  types.FETCH_ASSETS,
  (query) => () => api.fetchAssets(keysToSnakeCase(query))
);

export const fetchAsset = makeAsyncAction(
  types.FETCH_ASSET,
  (type, id, query) => () => api.fetchAsset(type, id, keysToSnakeCase(query)),
  undefined,
  {
    success: (dispatch, { type, payload }) => dispatch({ type, payload: decodeAsset(payload) })
  }
);

export const resetAsset = makeAsyncResetAction(types.RESET_ASSET);

export const saveAsset = makeAsyncAction(
  types.SAVE_ASSET,
  (asset, changes) => () => {
    // Used for any insert we might need to do
    let assetId = asset.id;

    // Turn the changes into { record: {}, verb: 'post|put|delete', path: '...' }
    changes.forEach(async (change) => {
      if (change.changes === null || change.changes === undefined || Object.keys(change.changes).length === 0) {
        return;
      }

      const call = buildCall(change, assetId);
      let response = null;

      switch (call.verb) {
        case 'POST':
          response = await api.createResource(call.url, call.data, call.options);

          if (change.type === 'facilities' || change.type === 'recareas') {
            assetId = response.FACILITYID || response.RECAREAID;
          }
          break;
        case 'PUT':
          response = await api.updateResource(call.url, call.data, call.options);
          break;
        case 'DELETE':
          response = await api.deleteResource(call.url);
          break;
        default:
        // no
      }
    });

    return Promise.resolve({ data: true });
  }
);

export const fetchAssetsForAutoComplete = makeAsyncAction(
  types.FETCH_ASSETS_FOR_AUTOCOMPLETE,
  (query) => () => api.fetchAssets(keysToSnakeCase(query))
//  (terms) => () => api.fetchAssets({ terms, assetTypes: ['recarea'] })
);

export const resetAssetsForAutoComplete = makeAsyncResetAction(types.RESET_ASSETS_FOR_AUTOCOMPLETE);
